import { useMemo } from 'react';
import Modal from '../ui/Modal';
import { useTranslation } from '@/i18n';

interface CircuitDayOperationModalProps {
  closeModal: () => void;
  operation: 'add' | 'remove' | 'duplicate';
  messages: string[];
  actionOnClick: () => void;
  shouldCloseModalAfterAction?: boolean;
}

const CircuitDayOperationModal = ({
  closeModal,
  operation,
  messages,
  actionOnClick,
  shouldCloseModalAfterAction = true,
}: CircuitDayOperationModalProps) => {
  const { t } = useTranslation();

  const title = useMemo(() => {
    switch (operation) {
      case 'add':
        return t('modal.circuitDayOperation.title.add');
      case 'remove':
        return t('modal.circuitDayOperation.title.remove');
      case 'duplicate':
        return t('modal.circuitDayOperation.title.duplicate');
    }
  }, [operation, t]);

  const actionTitle = useMemo(() => {
    switch (operation) {
      case 'add':
        return t('modal.circuitDayOperation.actionTitle.add');
      case 'remove':
        return t('modal.circuitDayOperation.actionTitle.remove');
      case 'duplicate':
        return t('modal.circuitDayOperation.actionTitle.duplicate');
    }
  }, [operation, t]);

  return (
    <Modal
      closeModal={closeModal}
      title={title}
      message={messages.join('\n\n')}
      actionTitle={actionTitle}
      actionOnClick={actionOnClick}
      shouldCloseModalAfterAction={shouldCloseModalAfterAction}
      specialColor={operation === 'remove' ? 'error' : undefined}
    />
  );
};

export default CircuitDayOperationModal;
